import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash-es';
import classnames from 'classnames';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { connectedInsiderSaveVinWrapper } from 'site-modules/shared/components/profile/insider-save-vin-wrapper/insider-save-vin-wrapper';

function InventoryHeartUI({
  isAuthenticated = null,
  CustomView,
  vehicle,
  isMobile = false,
  emptyIdmData = true,
  classes = '',
  userHasEmail = false,
  handleNonEmailUser = false,
  spinnerSize = null,
  trackingId = undefined,
  isActive = false,
  noSpinnerOnLoad = false,
  noCopy = false,
  wrapperClasses = '',
  ariaLabel = undefined,
  startInsiderAction,
}) {
  const [inProgress, toggleProgress] = useToggle(false);

  const handleClick = useCallback(
    (event, dealData) => {
      toggleProgress();

      return startInsiderAction(event, dealData).then(toggleProgress);
    },
    [startInsiderAction, toggleProgress]
  );

  const { vin } = vehicle;

  return (
    <div className={classnames('inventory-heart-wrapper', wrapperClasses)}>
      <CustomView
        active={isActive}
        spinnerSize={spinnerSize}
        disabled={inProgress || !!(isAuthenticated && emptyIdmData)}
        isAuthenticated={isAuthenticated}
        onClick={handleClick}
        userHasEmail={userHasEmail && handleNonEmailUser}
        trackingId={trackingId}
        trackingValue={vin}
        isMobile={isMobile}
        className={classes}
        vin={vin}
        noSpinner={noSpinnerOnLoad && isAuthenticated && emptyIdmData}
        noCopy={noCopy}
        ariaLabelExtra={ariaLabel ?? ''}
      />
    </div>
  );
}

InventoryHeartUI.propTypes = {
  vehicle: PropTypes.shape({
    vin: PropTypes.string.isRequired,
    vehicleInfo: PropTypes.shape({
      styleInfo: PropTypes.shape({
        make: PropTypes.string,
        year: PropTypes.number,
        model: PropTypes.string,
      }),
    }),
  }).isRequired,
  isAuthenticated: PropTypes.bool,
  CustomView: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isMobile: PropTypes.bool,
  emptyIdmData: PropTypes.bool,
  classes: PropTypes.string,
  userHasEmail: PropTypes.bool,
  handleNonEmailUser: PropTypes.bool,
  spinnerSize: PropTypes.number,
  trackingId: PropTypes.string,
  isActive: PropTypes.bool,
  startInsiderAction: PropTypes.func.isRequired,
  noSpinnerOnLoad: PropTypes.bool,
  noCopy: PropTypes.bool,
  wrapperClasses: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  emptyIdmData: isEmpty(get(state, 'profile.data.idm')),
});

export const InventoryHeart = connect(mapStateToProps)(connectedInsiderSaveVinWrapper(InventoryHeartUI, true));
export const InventoryHeartSave = connect(mapStateToProps)(connectedInsiderSaveVinWrapper(InventoryHeartUI, false));

InventoryHeart.propTypes = {
  vehicle: PropTypes.shape({}).isRequired,
  CustomView: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  wrapperClasses: PropTypes.string,
  ariaLabel: PropTypes.string,
};
